import $ from 'jquery'

$('.js-closeSearch').on('click', function() {
    $('html').removeClass('search-active');
    $('.searchform-wrapper').removeClass('is-open');

    $('.page-headerSearchContainer .page-headerButton').focus();
});
